import { Autocomplete, Button, Chip, Grid, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import DataTable from "../DataGrid/DataGrid";
import { useImmer } from "use-immer";
import { APP_BASE_URL, extractFilters, SFR_REPORTS } from "../../Common/EndPoints";
import axios from "axios";
import toast from "react-hot-toast";
import { GridColDef, GridRenderCellParams, GridValueGetterParams } from "@mui/x-data-grid";
// import { DatePicker } from "antd";
import dayjs from "dayjs";
import { getLocalStorage } from "../../Utils/storage-utils";
import { extractUserDataFromPermission } from "../../Utils/Utils";
import { getDeviceTypes } from "../Devices/Devices";
import { FIXED_DROPDOWNS } from "../SFR/utils/Constants";
import { AutocompleteStationListPop } from "../AutocompleteStationListPop/AutocompleteStationListPop";
import { Doughnut } from "react-chartjs-2";
import { generateColorFromNumber } from "../DFCCIL Dashboard/DFCCIL COMPONENT/ChartChainComponent/ChartChainComponent";
import "./mis.scss"

import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import { usePermissions } from "../../hooks/usePermissions";

const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

const { RangePicker } = DatePicker;

type IInitialState = {
  equipmentData: any[];
  departmentData: any[];
};

const initialState: IInitialState = {
  equipmentData: [],
  departmentData: [],
};

const initialFilters = {
  division: "",
  section: [],
  startTs: null,
  endTs: null,
};

const renderTotalRowAndColumn = (params: GridRenderCellParams) => (
  <div style={{ color: params.row.section === "Total" || params.colDef.field === "Total" ? "red" : "" }}>
    {params.value}
  </div>
);

const parseData = (data: any, allSection: any, items: any, isEquipment: any) => {
  const sections = new Map();

  allSection?.forEach((section: any) => {
    sections.set(section, {
      section,
      id: section,
      ...Object.fromEntries(items.map((item: any) => [isEquipment ? item.type : item.value, 0])),
    });
  });

  data.forEach(([key, section, value]: any) => {
    const sectionData = sections.get(section) || { section, [key]: 0 };
    sections.set(section, { ...sectionData, [key]: value });
  });

  const totalData = Object.fromEntries(
    items.map((item: any) => [
      isEquipment ? item.type : item.value,
      Array.from(sections.values()).reduce((acc, curr) => acc + Number(curr[isEquipment ? item.type : item.value]), 0),
    ]),
  );

  sections.set("Total", { section: "Total", id: "Total", ...totalData });

  return Array.from(sections.values());
};

const parseEquipmentData = (data: any, allSection: any, allDeviceTypes: any) =>
  parseData(data, allSection, allDeviceTypes, true);
const parseDepartmentData = (data: any, allSection: any, department: any) =>
  parseData(data, allSection, department, false);

function SFRReports() {
  const [state, setState] = useImmer(initialState);
  const [filter, setFilter] = useState<any>(initialFilters);
  const [sfrTableLoader, setSfrTableLoader] = useState(false);
  const [gearTypeList, setGearTypeList] = useState<any>(null);
  const departmentList = useMemo(() => {
    return FIXED_DROPDOWNS.department;
  }, []);

  async function handleFetchDeviceTypeList() {
    const _device_type_list = await getDeviceTypes();
    setGearTypeList(_device_type_list);
  }

  useEffect(() => {
    handleFetchDeviceTypeList();
  }, []);

  // const { divisionLists, station } = useMemo(() => {
  //   const divisionList = getLocalStorage("permissions", []);
  //   const { outerToInnerKeys: divisionLists, innerToCustomerNames: station }: any = extractUserDataFromPermission(
  //     JSON.parse(divisionList),
  //   );

  //   return {
  //     divisionLists,
  //     station,
  //   };
  // }, []);

  const { outerToInnerKeys: divisionLists, innerToCustomerNames: station } = usePermissions();

  const departmentTableColumns = useMemo<GridColDef[]>(() => {
    const columns: GridColDef[] = [
      {
        field: "section",
        headerName: "Division",
        sortable: true,
        minWidth: 180,
        flex: 1,
        hideable: true,
        renderCell: renderTotalRowAndColumn,
      },
      ...departmentList.map<GridColDef>((item) => ({
        field: item.value,
        headerName: item.value,
        sortable: true,
        minWidth: 180,
        flex: 1,
        hideable: true,
        renderCell: renderTotalRowAndColumn,
      })),
      {
        field: "Total",
        headerName: "Total",
        sortable: true,
        minWidth: 180,
        flex: 1,
        hideable: true,
        valueGetter: (params: GridValueGetterParams) =>
          departmentList.reduce((acc, curr) => {
            acc += Number(params.row[curr.value]);
            return acc;
          }, 0),
        renderCell: renderTotalRowAndColumn,
      },
    ];
    return columns;
  }, []);

  const equipmentTableColumns = useMemo<GridColDef[]>(() => {
    const columns: GridColDef[] = [
      {
        field: "section",
        headerName: "Division",
        sortable: true,
        minWidth: 180,
        flex: 1,
        hideable: true,
        renderCell: renderTotalRowAndColumn,
      },

      ...(gearTypeList || []).map(
        (item: any): GridColDef => ({
          field: item.type,
          headerName: item.type,
          sortable: true,
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderCell: renderTotalRowAndColumn,
        }),
      ),
      {
        field: "Total",
        headerName: "Total",
        sortable: true,
        minWidth: 180,
        flex: 1,
        hideable: true,
        valueGetter: (params: GridValueGetterParams) => {
          return (gearTypeList || []).reduce((acc: any, curr: any) => {
            acc += Number(params.row[curr.type]);
            return acc;
          }, 0);
        },
        renderCell: renderTotalRowAndColumn,
      },
    ];
    return columns;
  }, [gearTypeList]);

  useEffect(() => {
    if (gearTypeList?.length > 0) getSFRReports();
  }, [filter, gearTypeList]);

  const getSFRReports = async () => {
    try {
      setSfrTableLoader(true);
      const allSection = Object.keys(station);
      const { division, section, ...fil } = filter;

      const equipmentFilter = { ...fil, groupBy: "Type", zoneList: division, divisionList: section };
      const equipmentUrl = `${APP_BASE_URL}${SFR_REPORTS}/report?${extractFilters(equipmentFilter)}`;
      const equipmentRes = axios.get(equipmentUrl);

      const departmentFilter = { ...fil, groupBy: "Department", zoneList: division, divisionList: section };
      const departmentUrl = `${APP_BASE_URL}${SFR_REPORTS}/report?${extractFilters(departmentFilter)}`;
      const departmenttRes = axios.get(departmentUrl);

      // let filteredSections = division ? divisionLists[division] : allSection;
      let filteredSections = allSection;

      if (division && division.length > 0) {
        filteredSections = division.map((div: any) => divisionLists?.[div] || []).flat();
      }

      filteredSections =
        section && Array.isArray(section) && section.length > 0
          ? filteredSections.filter((sec: any) => section?.includes(sec))
          : filteredSections;

      const [equipmentData, departmentData] = await axios.all([equipmentRes, departmenttRes]);

      setState((state) => {
        state.equipmentData = parseEquipmentData(equipmentData?.data?.data || [], filteredSections, gearTypeList);
        state.departmentData = parseDepartmentData(departmentData?.data?.data || [], filteredSections, departmentList);
      });
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong");
        return;
      }
      console.log("SFR REPORTS ERROR", error)
      toast.error(error?.message ||"Something went wrong");
    } finally {
      setSfrTableLoader(false);
    }
  };

  const filterTableData = (filter: any) => {
    setFilter(filter);
  };

  const equipmentDoughnutData = useMemo(() => {
    const equipmentData = state.equipmentData
      .filter((item: any) => item.id !== "Total")
      .reduce((acc: any, curr: any) => {
        for (let key in curr) {
          if (key !== "section" && key !== "id") {
            acc[key] = curr[key] + (acc[key] || 0);
          }
        }
        return acc;
      }, {});

    const doughNutData = {
      labels: Object.keys(equipmentData).filter((key) => equipmentData[key] !== 0),
      datasets: [
        {
          data: Object.values(equipmentData).filter((value) => value !== 0),
          backgroundColor: Object.values(equipmentData)
            .filter((value) => value !== 0)
            .map((_, idx) => generateColorFromNumber(idx + 1)),
        },
      ],
    };

    return doughNutData;
  }, [state.equipmentData]);

  const branchDoughnutData = useMemo(() => {
    const departmentData = state.departmentData
      .filter((item: any) => item.id !== "Total")
      .reduce((acc: any, curr: any) => {
        for (let key in curr) {
          if (key !== "section" && key !== "id") {
            acc[key] = curr[key] + (acc[key] || 0);
          }
        }
        return acc;
      }, {});

    const doughNutData = {
      labels: Object.keys(departmentData).filter((key) => departmentData[key] !== 0),
      datasets: [
        {
          data: Object.values(departmentData).filter((value) => value !== 0),
          backgroundColor: Object.values(departmentData)
            .filter((value) => value !== 0)
            .map((_, idx) => generateColorFromNumber(idx + 1)),
        },
      ],
    };

    return doughNutData;
  }, [state.departmentData]);

  return (
    <div className="page-container--card" style={{ overflow: "auto" }}>
      <div className="flex justify-between">
        <Typography variant="h6" sx={{ fontWeight: "bold" }} textAlign={"start"}>
          Summary of Failures
        </Typography>
      </div>

      <UnhealthyAssetFilter filter={filter} onFilter={filterTableData} initialFilters={initialFilters} />
      <Typography variant="subtitle1" sx={{ textAlign: "center", fontWeight: "bold" }}>
        Equipment Wise Failure Position
      </Typography>

      <div style={{ minHeight: "400px", flexShrink: 0, display: "grid", gridTemplateColumns: "3fr 1fr", gap: "1rem" }}>
        <DataTable
          tableInfo={{
            id: `sfr-table-equipment`,
            label: `SFR Reports`,
            requireAuthSign: false,
            timestamp: { startTs: null, endTs: null },
          }}
          loading={sfrTableLoader}
          rows={state.equipmentData}
          pageSize={100}
          columns={equipmentTableColumns}
          hideExportPDF={true}
        />

        <div className="flex justify-center items-center" style={{ border: "1px solid #777" }}>
          {equipmentDoughnutData.labels.length > 0 ? (
            <Doughnut data={equipmentDoughnutData} />
          ) : (
            <Typography variant="body2">No Data Available </Typography>
          )}
        </div>
      </div>
      <Typography variant="subtitle1" sx={{ textAlign: "center", fontWeight: "bold", mt: 2 }}>
        Branch Wise Failure Position
      </Typography>
      <div style={{ minHeight: "400px", flexShrink: 0, display: "grid", gridTemplateColumns: "3fr 1fr", gap: "1rem" }}>
        <DataTable
          tableInfo={{
            id: `sfr-table-branch`,
            label: `SFR Reports`,
            requireAuthSign: false,
            timestamp: { startTs: null, endTs: null },
          }}
          loading={sfrTableLoader}
          rows={state.departmentData}
          columns={departmentTableColumns}
          pageSize={100}
          hideExportPDF={true}
        />

        <div className="flex justify-center items-center" style={{ border: "1px solid #777" }}>
          {branchDoughnutData.labels.length > 0 ? (
            <Doughnut data={branchDoughnutData} />
          ) : (
            <Typography variant="body2">No Data Available </Typography>
          )}
        </div>
      </div>
    </div>
  );
}

export default SFRReports;

const UnhealthyAssetFilter = ({
  filter,
  onFilter,
  initialFilters,
}: {
  filter: any;
  onFilter: any;
  initialFilters: any;
}) => {
  const [privateFilter, setPrivateFilter] = useImmer(filter);
  const { outermostKeys: divisions, outerToInnerKeys: divisionLists } = usePermissions();
  useEffect(() => {
    setPrivateFilter((draft: any) => {
      draft.division = (privateFilter?.division || [])?.filter((div: any) => divisions?.includes?.(div));
    })
  }, [divisions])
  
  useEffect(() => {
    const allSections = privateFilter?.division ? privateFilter?.division.map((div: any) => divisionLists?.[div] || []).flat() : [];
    setPrivateFilter((draft: any) => {
      draft.section = (privateFilter?.section || [])?.filter((section: any) => allSections?.includes?.(section));
    })
  }, [divisionLists])

  const onChangeFilter = (name: string, value: any) => {
    setPrivateFilter((draft: any) => {
      draft[name] = value;
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={3}>
        <Autocomplete
          fullWidth
          size="small"
          multiple
          disableCloseOnSelect
          className="filter-input auto-complete"
          options={divisions}
          renderInput={(params) => (
            <TextField className="filter-input" {...params} label="Zones" placeholder="Zones" />
          )}
          value={privateFilter?.division || []}
          onChange={(_, newValue) => {
            const allSections = newValue.map((div: any) => divisionLists?.[div] || []).flat();
            const filteredSections = privateFilter.section?.filter((section: any) => allSections.includes(section));
            onChangeFilter("division", newValue);
            onChangeFilter("section", filteredSections);
          }}
          renderTags={(value, getTagProps) => (
            <div>
              <Chip size="small" variant="outlined" label={value[0]} {...getTagProps({ index: 0 })} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((val) => val ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          )}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={3}>
        <Autocomplete
          fullWidth
          size="small"
          className="filter-input auto-complete"
          disableCloseOnSelect
          multiple
          options={privateFilter?.division ? privateFilter?.division.map((div: any) => divisionLists?.[div] || []).flat() : []}
          renderInput={(params) => (
            <TextField className="filter-input" {...params} label="Divisions" placeholder="Divisions" />
          )}
          value={privateFilter?.section || []}
          onChange={(_, newValue) => {
            onChangeFilter("section", newValue || []);
          }}
          renderTags={(value, getTagProps) => (
            <div>
              <Chip size="small" variant="outlined" label={value[0]} {...getTagProps({ index: 0 })} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((val) => val ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          )}
        />
      </Grid>

      <Grid item xs={12} md={6} lg={4}>
        <RangePicker
          className="fullWidth"
          size="large"
          placeholder={["Failure From Date", "Failure To Date"]}
          value={[
            privateFilter?.startTs ? dayjs(privateFilter?.startTs) : null,
            privateFilter?.endTs ? dayjs(privateFilter?.endTs) : null,
          ]}
          onChange={(dates) => {
            if (dates === null) {
              onChangeFilter("startTs", null);
              onChangeFilter("endTs", null);
              return;
            }

            onChangeFilter("startTs", dayjs(dates?.[0]).valueOf());
            onChangeFilter("endTs", dayjs(dates?.[1]).valueOf());
          }}
        />
      </Grid>
      <Grid item flex={1}>
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="contained" onClick={() => onFilter(privateFilter)}>
            Filter
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              onFilter(initialFilters);
              setPrivateFilter(initialFilters);
            }}
          >
            Clear
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};
